import { styled } from "@volkswagen-onehub/components-core";
import React, { createRef, useCallback, useEffect, useState } from "react";
import { LayerCloseHandle } from "../types/layers";
import { useFiltering } from "../utils/use-filtering";
import { ApplyButton } from "./ApplyButton";
import { ResetButton } from "./ResetButton";

const Container = styled.div<{fixButtons: boolean}>`
  margin: 0;
  width: 100%;
  padding: ${({theme}) => theme.size.dynamic0100} ${({theme}) => theme.size.dynamic0100};
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 1s ease-out;
  bottom: -100%;

  ${({fixButtons}) => fixButtons ? `
    position: sticky;
    bottom: 0;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.1) 0px -6px 30px, rgba(0, 0, 0, 0.2) 0px -4px 8px;
    transition: all 200ms ease-out;
  ` : null }
`;

interface Props {
  sectionHeight?: number;
  close: LayerCloseHandle;
};

export const FilterButtons = ({sectionHeight = 0, close}: Props) => {
  const buttonRef = createRef<HTMLDivElement>();
  const [ fixButtons, setFixButtons ] = useState(true);

  const { applySelectedFilters } = useFiltering();

  const handleClick = () => {
    applySelectedFilters();
    close();
  };

  const handleFixButton = () => {
    if (buttonRef?.current) {
      const el = buttonRef.current?.parentElement?.parentElement?.parentElement?.parentElement as HTMLDivElement;
      const yPosition = el.scrollTop + el.offsetHeight;
      const buttonContainerHeight = buttonRef?.current.offsetHeight;
      const yTrigger = sectionHeight + buttonContainerHeight - 1;
      if (yPosition >= yTrigger && fixButtons) {
        setFixButtons(false);
      } else if (yPosition < yTrigger && !fixButtons) {
        setFixButtons(true);
      }
    }
  }

  const handleScroll = useCallback(() => {
    handleFixButton();
  }, [buttonRef, sectionHeight]);

  useEffect(() => {
    const el = buttonRef.current?.parentElement?.parentElement?.parentElement?.parentElement as HTMLDivElement;
    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [handleScroll, buttonRef]);

  useEffect(() => {
    handleFixButton();
  }, [buttonRef, sectionHeight]);

  return (
    <Container ref={buttonRef} fixButtons={fixButtons}>
      <ApplyButton handleClick={handleClick} />
      <ResetButton />
    </Container>
  );
};
